module.exports = "/_next/static/resources/photo-2-550c8082d8352094086d2a8a92b77d2f.jpg";